const activeSubMenus = () => {
  // Function to display or hide submenus
  const subMenus = [
    {
      menu: document.getElementById('trainingMenu'),
      dropdownMenu: document.getElementById('trainingDropdownMenu')
    },
    {
      menu: document.getElementById('featuresMenu'),
      dropdownMenu: document.getElementById('featuresDropdownMenu')
    }
  ];

const toggleMenu = (currentMenu, hiddenMenus) => {
  let timeoutId;

  const showMenu = () => {
    clearTimeout(timeoutId);
    currentMenu.dropdownMenu.classList.add('active');
    currentMenu.menu.classList.add('active');
  };

  const hideMenu = () => {
    timeoutId = setTimeout(() => {
      currentMenu.dropdownMenu.classList.remove('active');
      currentMenu.menu.classList.remove('active');
    }, 500);
  };

  currentMenu.menu.addEventListener('mouseenter', showMenu);
  currentMenu.menu.addEventListener('mouseleave', hideMenu);
  currentMenu.dropdownMenu.addEventListener('mouseenter', showMenu);
  currentMenu.dropdownMenu.addEventListener('mouseleave', hideMenu);
};

  const addSubMenuListeners = () => {
    subMenus.forEach((currentMenu, index) => {
      if (currentMenu.menu && currentMenu.dropdownMenu) {
        // hiddenMenus is composed of all the menus except the active currentMenu
        const hiddenMenus = subMenus.filter((_, i) => i !== index);
        toggleMenu(currentMenu, hiddenMenus);
      }
    });
    autoMenuItemsDisplay(subMenus);
  };

  addSubMenuListeners();

};

  const mobileAccordionMenu = () => {
    // Activate the accordion functionality for the mobile menu

    const accordionThumbs = document.querySelectorAll('.dp-accordion-thumb');

    accordionThumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {

        const arrow = thumb.querySelector('.arrow');
        const panel = thumb.nextElementSibling;
        if (!panel) return;

        if (panel.classList.contains('open')) {
          panel.classList.remove('open');
          arrow.classList.remove('open');
        } else {
          document.querySelectorAll('.dp-accordion-panel.open').forEach(openPanel => {
            openPanel.classList.remove('open');
            openPanel.previousElementSibling.querySelector('.arrow').classList.remove('open');
          });

          panel.classList.add('open');
          arrow.classList.add('open');
        }
      });
    });

  }

  const mobileMenuStyle = () => {
    // This function only provides styles to the mobile menu
    document.querySelectorAll('.home-menu__mobile__item li > a').forEach(element => {
      let textNodes = Array.from(element.childNodes).filter(node => node.nodeType === Node.TEXT_NODE);
      if (textNodes.length > 0) {
        let textNode = textNodes[0];
        let text = textNode.textContent.trim().toLowerCase();
        textNode.textContent = text.charAt(0).toUpperCase() + text.slice(1);
      }
      element.classList.add('first-letter-uppercase');
    });

  }

  const autoMenuItemsDisplay = (subMenus) => {
    //This function affects the desktop menu. It detects when the mouse passes over one of the drop-down items to
    // automatically open the submenu, and also closes it when exiting it.
    subMenus.forEach(({ dropdownMenu, menu }) => {
      dropdownMenu.addEventListener('mouseenter', () => {
        dropdownMenu.classList.add('active');
        menu.classList.add('active');
      });
      dropdownMenu.addEventListener('mouseleave', () => {
        dropdownMenu.classList.remove('active');
        menu.classList.remove('active');
      });
    });
  }

  const activeMoreItemMenu = () => {
    //This function affects the desktop menu. It detects when the mouse hovers
    //over the more item to open and activate the footer items in the menu, and also closes it when you exit it.
    const moreButton = document.querySelector('#menu-toggle a');
    const footerMenu = document.querySelector('footer .section--links');
    let isMoreButtonHovered = false;
    let isFooterMenuHovered = false;


    const openMenu = () => {
      moreButton.classList.add('open');
      document.querySelector('body').classList.add('collapse');
    };

    // Function to close the menu only if the mouse is not on either of the two items
    const closeMenu = () => {
      if (!isMoreButtonHovered && !isFooterMenuHovered) {
        moreButton.classList.remove('open');
        document.querySelector('body').classList.remove('collapse');
      }
    };

    moreButton.addEventListener('mouseenter', () => {
      isMoreButtonHovered = true;
      openMenu();
    });

    moreButton.addEventListener('mouseleave', () => {

      setTimeout( () => {
        isMoreButtonHovered = false;
        closeMenu();
      }, 100);
    });


    footerMenu.addEventListener('mouseenter', () => {
      if(isMoreButtonHovered){
        isFooterMenuHovered = true;
        openMenu();
      }

    });

    footerMenu.addEventListener('mouseleave', () => {
      isFooterMenuHovered = false;
      setTimeout(closeMenu, 100);
    });

  }

  const activeMenuProperties = () => {
    document.addEventListener('DOMContentLoaded', () => {
      activeSubMenus();
      mobileAccordionMenu();
      mobileMenuStyle();
      activeMoreItemMenu();
    });
  }

  activeMenuProperties();
